import { useStoreMap } from 'effector-react'
import { useState } from 'react'
import { driverModel } from '~/entities/Driver'
import { Button } from '~/shared/ui/Buttons'
import { Wrapper } from './styled'

type ConfirmationRequiredProps = {
  onCodeRepeat: () => void | Promise<void>
}

export function ConfirmationRequired({
  onCodeRepeat,
}: ConfirmationRequiredProps) {
  const [isLoading, toggleIsLoading] = useState<boolean>()

  const email = useStoreMap(driverModel.$driver, (driver) => driver?.getEmail())
  const emailVerifiedAt = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getEmailVerifiedAt(),
  )

  const handleCodeRepeat = async () => {
    try {
      toggleIsLoading(true)
      await onCodeRepeat()
    } finally {
      toggleIsLoading(false)
    }
  }

  if (!email || emailVerifiedAt) return null

  return (
    <Wrapper>
      <div style={{ fontSize: '18px', fontWeight: 700, marginBottom: '8px' }}>
        Требуется подтверждение по Email
      </div>

      <div style={{ fontSize: '16px', marginBottom: '8px' }}>
        Для подтверждения перейдите по ссылке из письма, отправленного на Email,
        указанный при регистрации.
      </div>

      <Button
        onClick={handleCodeRepeat}
        loading={isLoading}
        variant='textLink'
        contentProps={{ style: { padding: 0 } }}
      >
        Выслать письмо повторно
      </Button>
    </Wrapper>
  )
}
